import React from "react";
import {UserInfoModel} from "app/model/ua/user-info";
import {useAppSelector} from "app/store/hook";
import ArcDigitalClock from "app/components/arc/ArcDigitalClock";
import WeatherInfo from "app/components/common/WeatherInfo";
import {Helmet} from "react-helmet-async";
import {Link, useNavigate} from "react-router-dom";

export interface DbUserTitleProps {
  title?: string;
  configButtonVisible?: boolean;
}

export default function DbUserTitle(props: Readonly<DbUserTitleProps>) {
  const userInfo: UserInfoModel = useAppSelector(state => state.userInfo.userInfo);
  const navigate = useNavigate();

  function handleClickConfigButton(e: any) {
    e.preventDefault();
    navigate('/db/user/config');
  }

  return (
    <>
      {userInfo && (
        <>
          <Helmet>
            <title>{props.title ?? 'eCloud 플랫폼'}</title>
          </Helmet>
          <div className="main-tit">
            <span className="name"><strong>{userInfo.userNm}</strong>님 안녕하세요.</span>
            <div className="flexWrap4">
              <span className="ymd-i">
                <ArcDigitalClock/>
              </span>
              <WeatherInfo/>
              {props.configButtonVisible && (
                <span className="ymd-i">
                  {/*<ArcJoyride steps={joyrideUtils.dashboard} saveName="dashboard" />*/}
                  <Link to="#" className="btn-layer" title="대시보드 설정하기" onClick={handleClickConfigButton} />
                </span>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}